module.exports = __webpack_public_path__ + "static/media/left-side.d63ee0bf.png";